// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import InstructionsList from './instructions-list';
import OtherInstruction from '@deere/cps-it.warranty-model-factory/lib/other-instruction';

const OtherInstructions = props => {

    const title = <FormattedMessage id='OTHER_INSTRUCTIONS'/>;

    const body = <InstructionsList instructions={props.otherInstructions}/>;

    return (
        props.otherInstructions.length > 0 &&
            <Accordion
                accordionId='other-instructions-accordion'
                body={body}
                isExpanded={true}
                title={title}
            />
    );

};

OtherInstructions.displayName = 'OtherInstructions';
OtherInstructions.propTypes = {
    otherInstructions: PropTypes.arrayOf(PropTypes.instanceOf(OtherInstruction)).isRequired
};

export default OtherInstructions;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/instructions-panels/other-instructions.js